import React, { useEffect } from "react";
import "react-multi-carousel/lib/styles.css";
import { connect } from "react-redux";
import { getAllAccessories } from "../../../../redux/actions/accessories";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import CardAccessories from "./components/CardAccessories/CardAccessories";
import { Loader } from "semantic-ui-react";
const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 924 },
    items: 4,
    paritialVisibilityGutter: 60
  },
  tablet: {
    breakpoint: { max: 924, min: 600 },
    items: 2,
    paritialVisibilityGutter: 50
  },
  mobile: {
    breakpoint: { max: 600, min: 0 },
    items: 1,
    paritialVisibilityGutter: 0
  }
};
const CarouselAccessories = ({ categoryid, accesories, getAllAccessories }) => {
  useEffect(() => {
    getAllAccessories(categoryid);
  }, [categoryid, getAllAccessories]);
  return (
    <div className="pl-4 pr-4 pt-5">
      {accesories.loading ? (
        <Loader active inline="centered" />
      ) : (
        <div>
          <div className="text-center pb-5">
            <h2 className="font-weight-bold">
              ¡ Haz que tu arreglo luzca mejor !
            </h2>
          </div>
          <Carousel
            itemClass="image-item"
            draggable={true}
            swipeable={true}
            autoPlay={true}
            infinite={true}
            responsive={responsive}
            className="carousel"
          >
            {accesories.accessories.map(accesory => (
              <center key={accesory.id}>
                <CardAccessories array={accesory} />
              </center>
            ))}
          </Carousel>
        </div>
      )}
    </div>
  );
};
const mapStateToProps = state => {
  return {
    accesories: state.accessories
  };
};

export default connect(mapStateToProps, {
  getAllAccessories
})(CarouselAccessories);
